import { render, staticRenderFns } from "./SellerList.vue?vue&type=template&id=605e8497&"
import script from "./SellerList.vue?vue&type=script&lang=js&"
export * from "./SellerList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports